// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"885b9fc3","437":"c1dca551","455":"a6109696","761":"17982700"}[chunkId] + ".chunk.css";
};